import * as React from 'react';
import * as styled from './styled';
import ReactSlider, {ReactSliderProps} from 'react-slider';

/**
 *
 * @param {ReactSliderProps} props
 * @return {React.ReactElement<ReactSliderProps>}
 * @constructor
 */
export default function InputRange(
    props: ReactSliderProps,
): React.ReactElement<ReactSliderProps> {
  return (
    <styled.Wrapper color="#69F880">
      <ReactSlider
        {...props}
        className="slider"
        thumbClassName="thumb"
        trackClassName="track"
      />
    </styled.Wrapper>
  );
}
